import { msalApp, MSAL_AUTHENTICATION_PARAMETERS} from '../utils/auth'
export default class AuthService {
  
  completedAction = null;
  _msalApp =  null;
  constructor() {
    this._msalApp = msalApp
    const authCallback = (error, response) => {
      if (error) {
        // console.log(error) 
      }
      else {
        if (response.tokenType === "id_token" && response.idToken.claims['acr'] === process.env.REACT_APP_B2C_POLICY_CONVERT_MERGE_SIGNIN) {
          if (this._msalApp.getAccount()) {
            // eslint-disable-next-line
            const idToken = this._msalApp.getAccount().idTokenClaims.sub
          }
        }
        
        else if (response.tokenType === "access_token") {
          // console.log(response)
        } 
        else {
          //console.log("Token type is: " + response.tokenType)
          
        }
      }
    }

    this._msalApp.handleRedirectCallback(authCallback)
  }

  setAuthority(authority) {
    this._msalApp.authority = authority
  }

  loginRedirect(config= {}){
    this._msalApp.loginRedirect({
      ...MSAL_AUTHENTICATION_PARAMETERS,
      ...config,
    })
  }

  getAccessToken(){
    
    return this._msalApp.acquireTokenSilent({
      ...MSAL_AUTHENTICATION_PARAMETERS,
    })
      .then((accessTokenResponse) => {
        return accessTokenResponse
      })
      .catch((error) => {
        console.warn("Silent token acqusition failed:",error);
        return this._msalApp.acquireTokenPopup({
          ...MSAL_AUTHENTICATION_PARAMETERS,
        });
      })
  }

  getAccessTokenOrLogin(){
    const isIframe=window!==window.parent;
    const isMissingSSOError = (error) => {
      return error.message && error.message.match(/User login is required/);
    }
    
    return this._msalApp.acquireTokenSilent({
      ...MSAL_AUTHENTICATION_PARAMETERS,
    })
      .then((accessTokenResponse) => {
        return accessTokenResponse;
      }).catch((error) => {
        
        if(error.message && error.errorMessage?.includes("AADB2C90077"))
        {
          if(isIframe){
            return this._msalApp.acquireTokenPopup({
              authority:process.env.REACT_APP_MSAL_CONVERT_MERGE_SIGNIN_AUTHORITY,
              scopes: [process.env.REACT_APP_B2C_SCOPES],
            });
          }
          else{
          return this._msalApp.acquireTokenRedirect({
            authority: process.env.REACT_APP_MSAL_CONVERT_MERGE_SIGNIN_AUTHORITY,
            scopes: [process.env.REACT_APP_B2C_SCOPES],
          });
        } 
        }

        else if(isMissingSSOError(error)) {
          if(isIframe){
            return this._msalApp.loginPopup({
             ...MSAL_AUTHENTICATION_PARAMETERS,
            });
          }else{
            return this._msalApp.loginRedirect({
            ...MSAL_AUTHENTICATION_PARAMETERS,
            auth: {
              ...(MSAL_AUTHENTICATION_PARAMETERS.auth || {}),
              navigateToLoginRequestUrl: false,
            },
          });
          }
        } 
           console.error("Unhandled MSAL error",error);
        throw error;
        });
      
  }

  logout(){
    this._msalApp.logout()
  }
  
}
